// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '../../../hoc/withStyles';
import TextBox from '../../TextBox';
import Image from '../../Image';
import BodyCopy from '../../BodyCopy';
import { getIconPath } from '../../../../../utils';
import styles from '../styles/CreditCardNumber.style';
import useCreditCardNumber from '../hooks/useCreditCardNumber';

const getCardTypeImgUrl = (cardType) => {
  const isPJPCard = cardType?.toLowerCase().includes('place');
  const iconPath = `${
    !isPJPCard ? (cardType || '').toLowerCase().replace(' ', '-') : 'place-card-pjp'
  }-small`;

  return getIconPath(iconPath);
};

const getAltValues = (cardType) => {
  const altValues = {
    VISA: 'Visa Card',
    MC: 'Master Card',
    DISC: 'Discover Card',
    AMEX: 'American Express Card',
  };
  return altValues[cardType];
};

export const CreditCardNumber = ({
  cardType,
  className,
  input,
  showIndicatorIcon,
  ...otherProps
}) => {
  const [ref, inputProps] = useCreditCardNumber({
    input,
  });

  const {
    meta: { valid },
  } = otherProps;

  return (
    <BodyCopy component="div" className={className}>
      <TextBox maxLength="19" {...otherProps} showIndicatorIcon input={inputProps} inputRef={ref} />
      {cardType && valid && (
        <Image src={getCardTypeImgUrl(cardType)} alt={getAltValues(cardType)} role="img" />
      )}
    </BodyCopy>
  );
};

CreditCardNumber.propTypes = {
  cardType: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  input: PropTypes.shape({}).isRequired,
  showIndicatorIcon: PropTypes.bool.isRequired,
};

export default withStyles(CreditCardNumber, styles);
export { CreditCardNumber as CreditCardNumberVanilla };
